import ApiService from '@/services/api.service';

const PrescriptionSignaturesService = {
    bulk(data) {
        return ApiService.post('/PrescriptionSignatures/bulk', data);
    },
    undoBulk(prescriptionIds) {
        return ApiService.delete('/PrescriptionSignatures/bulk', prescriptionIds);
    }
};

export default PrescriptionSignaturesService;
